$shm_hitalama_components_tests $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	selected? \
	title \Тесты
	minimal_width 304
	body <= content_rows /
	Scenarios $shm_tree
		roots <= tree_roots /
		children* <= tree_children* /
		expanded_default* false
		Item* <= Scenario_item*
	Empty $mol_view
		sub / \Тестов пока нет
	Scenario_item* $mol_button_minor
		attr *
			^
			selected <= tree_selected* false
		title <= tree_title* \
		click? <=> choose*? null
